module.exports = __webpack_public_path__ + "media/images/athletes/3579-ce720a72d0ab18a8c9b064dae49790b5.png";